import { NotepadTextIcon } from 'lucide-react';

export const NoteIcon = NotepadTextIcon;
